import { useState, useEffect } from "react";
import { useNavigate, useParams, useLocation } from 'react-router-dom';

//import resources
import { FaSearch } from "react-icons/fa";

//import locales
import { useTranslation } from "react-i18next";
import "../../../i18n";

export default function Search () {

    const location = useLocation();

    //get locale
    const { t } = useTranslation();
    const { locale } = useParams();

    const navigate = useNavigate();

    const [searchKey, setSearchKey] = useState('');

    const search = () => {
        navigate(`/${locale}/search?keyword=${searchKey}`);
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            search();
        }
    };

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const keyword = params.get('keyword') || '';
        setSearchKey(keyword);
    }, [location]);

    return (
        <>
            <div className="h-full flex items-center relative">
                <input value={searchKey} onKeyDown={handleKeyDown} onChange={(e)=>setSearchKey(e.target.value)} type="text" name="search" className="border border-gray-300 text-slate-900 text-sm rounded-3xl block w-full px-3 h-[50px] !outline-none placeholder:text-slate-500" placeholder={t('search_word')} />
                <button className="absolute rounded-3xl bg-[var(--orange)] px-10 h-[44px] right-0 me-0.5 top-0 mt-[6px] text-white" onClick={()=>search()}>
                    <FaSearch className="color-white" />
                </button>
                
            </div>
            
            
        </>
    );
}